import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  StatusChangeEvent,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { InformationsFormGroup } from './informations-form.types';
import { AnotaValidators } from '@app/helpers/AnotaValidators';

export const VALID_PHONE_NUMBER_LENGTH = 11;

export class InformationsFormFactory {
  private readonly INVALID_PHONE_NUMBERS: string[] = [];
  private readonly formBuilder: FormBuilder = new FormBuilder();

  private readonly FORM_VALIDATORS = [AnotaValidators.formGroup];

  private readonly orderPerDayValidators: ValidatorFn[] = [AnotaValidators.required];

  private readonly companyValidators: ValidatorFn[] = [
    AnotaValidators.required,
    (control: AbstractControl) => {
      const pattern = /^[a-zA-ZÀ-ÿ0-9\s.,\-°ºª]+$/;
      if (control.value && !pattern.test(control.value)) {
        return { message: 'Nome da loja contém caracteres inválidos' };
      }
      return null;
    }
  ];
  private readonly computerValidators: ValidatorFn[] = [AnotaValidators.required];
  private readonly nameValidators: ValidatorFn[] = [
    AnotaValidators.required,
    (control: AbstractControl) => {
      const pattern = /^[a-zA-ZÀ-ÿ\s.,\-°ºª]+$/;
      if (control.value && !pattern.test(control.value)) {
        return { message: 'Nome contém caracteres inválidos' };
      }
      return null;
    }
  ];
  private readonly emailValidators: ValidatorFn[] = [AnotaValidators.required, AnotaValidators.email];

  private readonly phoneValidators: ValidatorFn[] = [
    AnotaValidators.required,
    AnotaValidators.minLength(VALID_PHONE_NUMBER_LENGTH),
    AnotaValidators.maxLength(VALID_PHONE_NUMBER_LENGTH),
    (control: AbstractControl) => {
      if (this.INVALID_PHONE_NUMBERS.includes(control.value)) {
        return { whatsapp: true, message: 'Este número não possui WhatsApp' };
      }
      return null;
    },
  ];

  private readonly invoicingValidators = [AnotaValidators.required];

  public create(): FormGroup<InformationsFormGroup> {
    const phone = new FormControl(null, this.phoneValidators);

    phone.events.forEach(e => {
      if (
        e instanceof StatusChangeEvent &&
        e.status === 'INVALID' &&
        e.source.value?.length === VALID_PHONE_NUMBER_LENGTH
      ) {
        if (!this.INVALID_PHONE_NUMBERS.includes(e.source.value)) {
          this.INVALID_PHONE_NUMBERS.push(e.source.value);
          e.source.updateValueAndValidity({ emitEvent: false });
        }
      }
    });

    const form = this.formBuilder.nonNullable.group<InformationsFormGroup>({
      phone,
      name: new FormControl(null, this.nameValidators),
      email: new FormControl(null, this.emailValidators),
      company: new FormControl(null, this.companyValidators),
      computer: new FormControl(null, this.computerValidators),
      computer_access_label: new FormControl(null),
      order_day: new FormControl(null, this.orderPerDayValidators),
      acceptTerms: new FormControl(null),
      waiter_quantity: new FormControl(null, []),
      waiter_tables: new FormControl(null, []),
      ipAddress: new FormControl(),
      deal_id: new FormControl(),
      force_billing_core_subscription: new FormControl(),
      force_central_account: new FormControl(),
      invoicing: new FormControl(null, this.invoicingValidators)
    }, { validators: this.FORM_VALIDATORS });

    return form;
  }
}
